import { FaGithub, FaLinkedin } from "react-icons/fa6";
import About from "./About";
import Footer from "./Footer";
import Project from "./project";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <div>
      <div class="flex flex-col items-center mx-5 my-5 p-5 bg-gray-100 drop-shadow-md rounded-lg shadow-lg shadow-indigo-500/40">
        <img
          class="w-40 h-40 border-2 border-indigo-500 rounded-full object-cover drop-shadow-lg"
          src="./dev2.jpg"
          alt="scientist"
        />
        <div class="text-center pt-5 leading-10">
          <h2 class="text-xl sm:text-3xl font-bold font-sans tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-cyan-500 to-blue-500">
            Devesh Sahu
          </h2>
          <h3 class="text-sm pt-1 text-slate-400 sm:text-xl">Web developer</h3>
        </div>
      </div>
      <div class="flex flex-row justify-center items-center  ">
        <div class="box-border h-10 w-10 border-2 border-indigo-300 flex justify-center items-center rounded-lg bg-gray-100 m-2">
          <Link to="https://www.linkedin.com/in/devesh-sahu-93a6981b4">
            <FaLinkedin size="1.5em" color="#0A66C2" />
          </Link>
        </div>

        <div class="box-border h-10 w-10 border-2 border-indigo-300 flex justify-center items-center rounded-lg bg-gray-100 m-2">
          <Link to="https://github.com/devesh-dev">
            <FaGithub size="1.5em" class="m-1" color="#171515" />
          </Link>
        </div>
      </div>
      <About />
      <Project />
      <Footer />
    </div>
  );
};

export default Hero;
